
import { Modal } from "@/components";
import { Button } from "@/components/Form";
import { Money } from "v-money";
import { priceOptions, quantityOptions } from "@/modules/Application";
import { SistemaMixin } from "@/modules/Application";
import FormatMixin from "@/modules/Application/mixins/FormatMixin";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";
import "vue-select/dist/vue-select.css";

export default {
  name: "ModalServico",
  mixins: [FormatMixin, PessoaMixin, SistemaMixin],
  components: {
    Modal,
    Button,
    Money,
  },
  data() {
    return {
      valueServico: {},
      priceOptions,
      quantityOptions,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    changeServico: {
      type: Function,
      required: true,
    },
    servico: {
      type: Object,
      required: true,
    },
  },
  watch: {
    servico(newValue) {
      this.valueServico = newValue;
    },
  },
  mounted() {
    console.log();
    this.valueServico = this.servico;
    this.getDataInit();
  },
  methods: {
    save() {
      this.valueServico.total =
        this.valueServico.unitario * this.valueServico.quantidade;
      this.changeServico(this.valueServico);
      this.$toast.success("Serviço editado com sucesso!");
    },
    async getDataInit() {},
  },
  computed: {
    totalServico() {
      return this.valueServico.quantidade * this.valueServico.unitario;
    },
  },
};
